/**
 * Configuración centralizada para las páginas del dashboard
 * 
 * Este archivo contiene todas las configuraciones de las páginas del dashboard.
 * Para agregar una nueva página, simplemente agrega un objeto al array dashboardPages.
 * 
 * Estructura:
 * - name: Nombre visible en el header y menú
 * - value: Identificador único de la página
 * - icon: Nombre del icono (debe existir en Icon component)
 * - component: Componente React a renderizar
 * - url: URL de la página (para navegación futura)
 */

import SolicitudManagement from "@/components/features/solicitudes/SolicitudManagement"; // New modular component
import ContactadosManagement from "@/components/features/solicitudes/ContactadosManagement";
import EntregadosARiesgosManagement from "@/components/features/solicitudes/EntregadosARiesgosManagement";
import RevisionDocumentalManagement from "@/components/features/solicitudes/RevisionDocumentalManagement";
import PreAnalisisManagement from "@/components/features/solicitudes/PreAnalisisManagement";
import AnalisisCreditosManagement from "@/components/features/solicitudes/AnalisisCreditosManagement";
import MesaDeAnalisisManagement from "@/components/features/analisis/MesaDeAnalisisManagement";
import SolicitarVoBosManagement from "@/components/features/solicitudes/SolicitarVoBosManagement";
import AutorizacionRiesgosManagement from "@/components/features/solicitudes/AutorizacionRiesgosManagement";
import AutorizacionDGManagement from "@/components/features/solicitudes/AutorizacionDGManagement";
import ImprimirContratoManagement from "@/components/features/solicitudes/ImprimirContratoManagement";
import FirmarContratoManagement from "@/components/features/solicitudes/FirmarContratoManagement";
import PorFondearManagement from "@/components/features/solicitudes/PorFondearManagement";
import TransferenciasManagement from "@/components/features/solicitudes/TransferenciasManagement";
import FondeadosManagement from "@/components/features/solicitudes/FondeadosManagement";
import RechazadosManagement from "@/components/features/solicitudes/RechazadosManagement";
import ClabesManagement from "@/components/features/solicitudes/ClabesManagement";
import CobranzaManagement from "@/components/features/solicitudes/CobranzaManagement";
import ControlExpedientesManagement from "@/components/features/solicitudes/ControlExpedientesManagement";
import HistoricoManagement from "@/components/features/solicitudes/HistoricoManagement";
import SimuladorManagement from "@/components/features/simulador/SimuladorManagement";
import SeguimientoDiarioManagement from "@/components/features/reportes/SeguimientoDiarioManagement";
import PipelineManagement from "@/components/features/reportes/PipelineManagement";
import ScoreCardManagement from "@/components/features/reportes/ScoreCardManagement";
import ColocacionManagement from "@/components/features/reportes/ColocacionManagement";
import CumplimientoManagement from "@/components/features/reportes/CumplimientoManagement";
import CosechasManagement from "@/components/features/reportes/CosechasManagement";
import OperacionesInternasPreocupantesManagement from "@/components/features/reportes/OipManagement";
import ReporteVentasManagement from "@/components/features/reportes/ReporteVentasManagement";
import AgendasManagement from "@/components/features/reportes/AgendasManagement";
import LogsManagement from "@/components/features/reportes/LogsManagement";
import VisitasManagement from "@/components/features/reportes/VisitasManagement";
import BackupsManagement from "@/components/features/reportes/BackupsManagement";
import SesionesManagement from "@/components/features/reportes/SesionesManagement";
import ReporteTextoManagement from "@/components/features/reportes/ReporteTextoManagement";
import PerfilManagement from "@/components/features/admin/PerfilManagement";
import AsignacionesManagement from "@/components/features/admin/AsignacionesManagement";
import EmpresaManagement from "@/components/features/empresas/EmpresaManagement"; // New modular component
import UserManagement from "@/components/features/users/UserManagement"; // New modular component
import PagadorasManagement from "@/components/features/pagadoras/PagadorasManagement";
import ACLManagement from "@/components/features/acl/ACLManagement";
import ParametricosManagement from "@/components/features/admin/ParametricosManagement";
import HomePage from "@/components/features/home/HomePage";
import AyudaManagement from "@/components/features/ayuda/AyudaManagement";
import { DashboardPageConfig, MenuItem } from "@/types/dashboard";
import { IconName } from "@/components/ui/icons";

export const dashboardPages: DashboardPageConfig[] = [
  {
    name: "Inicio",
    value: "menuHome",
    icon: "home",
    component: HomePage,
    url: "/home",
  },
  {
    name: "Agendas",
    value: "menuAgendas",
    icon: "file",
    component: AgendasManagement,
    url: "/agendas",
  },
  {
    name: "Solicitudes",
    value: "menuSolicitudes",
    icon: "file",
    component: SolicitudManagement,
    url: "/solicitudes",
  },
  {
    name: "Contactados",
    value: "menuContactados",
    icon: "phone",
    component: ContactadosManagement,
    url: "/contactados",
  },
  {
    name: "Entregados a Riesgos",
    value: "menuEntregadosaRiesgos",
    icon: "alert",
    component: EntregadosARiesgosManagement,
    url: "/entregadosariesgos",
  },
  {
    name: "Mesa de Analisis",
    value: "menuMesaDeAnalisis",
    icon: "search",
    component: MesaDeAnalisisManagement,
    url: "/mesadeanalisis",
  },
  {
    name: "Revision Documental",
    value: "menuRevisionDocumental",
    icon: "doc",
    component: RevisionDocumentalManagement,
    url: "/revisionDocumental",
  },
  {
    name: "Pre Análisis",
    value: "menuPreAnalisis",
    icon: "chart",
    component: PreAnalisisManagement,
    url: "/pre-analisis",
  },
  {
    name: "Analisis de Creditos",
    value: "menuAnalisisCreditos",
    icon: "card",
    component: AnalisisCreditosManagement,
    url: "/analisis-creditos",
  },
  {
    name: "Solicitar VoBo's",
    value: "menuSolicitarVoBos",
    icon: "check",
    component: SolicitarVoBosManagement,
    url: "/solicitarvobos",
  },
  {
    name: "Autorización Riesgos",
    value: "menuAutorizacionRiesgos",
    icon: "lock",
    component: AutorizacionRiesgosManagement,
    url: "/autorizacionriesgos",
  },
  {
    name: "Autorización DG",
    value: "menuAutorizacionDG",
    icon: "badge",
    component: AutorizacionDGManagement,
    url: "/autorizaciondg",
  },
  {
    name: "Imprimir Contrato",
    value: "menuImprimirContrato",
    icon: "print",
    component: ImprimirContratoManagement,
    url: "/imprimircontrato",
  },
  {
    name: "Firmar Contrato",
    value: "menuFirmarContrato",
    icon: "pen",
    component: FirmarContratoManagement,
    url: "/firmarcontrato",
  },
  {
    name: "Por Fondear",
    value: "menuPorFondear",
    icon: "dollar",
    component: PorFondearManagement,
    url: "/porfondear",
  },
  {
    name: "Transferencias",
    value: "menuTransferencias",
    icon: "transfer",
    component: TransferenciasManagement,
    url: "/transferencias",
  },
  {
    name: "Fondeados",
    value: "menuFondeados",
    icon: "check",
    component: FondeadosManagement,
    url: "/fondeados",
  },
  {
    name: "Rechazados",
    value: "menuRechazados",
    icon: "x",
    component: RechazadosManagement,
    url: "/rechazados",
  },
  {
    name: "Control de Expedientes",
    value: "menuControlExpedientes",
    icon: "folder",
    component: ControlExpedientesManagement,
    url: "/controlexpedientes",
  },
  {
    name: "Cobranza",
    value: "menuCobranza",
    icon: "dollar",
    component: CobranzaManagement,
    url: "/cobranza",
  },
  {
    name: "Historico",
    value: "menuHistorico",
    icon: "book",
    component: HistoricoManagement,
    url: "/historico",
  },
  {
    name: "Simulador",
    value: "menuSimulador",
    icon: "calc",
    component: SimuladorManagement,
    url: "/simulador",
  },
  {
    name: "Seguimiento Diario",
    value: "seguimientoDiario",
    icon: "trend",
    component: SeguimientoDiarioManagement,
    url: "/seguimientodiario",
  },
  {
    name: "PipeLine",
    value: "menuPipeLine",
    icon: "refresh",
    component: PipelineManagement,
    url: "/pipeline",
  },
  {
    name: "ScoreCard",
    value: "menuScoreCard",
    icon: "chart",
    component: ScoreCardManagement,
    url: "/scorecard",
  },
  {
    name: "Colocación",
    value: "menuColocacion",
    icon: "chart",
    component: ColocacionManagement,
    url: "/colocacion",
  },
  {
    name: "Cumplimiento",
    value: "menuCumplimiento",
    icon: "check",
    component: CumplimientoManagement,
    url: "/cumplimiento",
  },
  {
    name: "Cosechas",
    value: "menuCosechas",
    icon: "leaf",
    component: CosechasManagement,
    url: "/cosechas",
  },
  {
    name: "Operaciones Internas Preocupantes",
    value: "menuOIP",
    icon: "alert",
    component: OperacionesInternasPreocupantesManagement,
    url: "/operaciones-internas-preocupantes",
  },
  {
    name: "Reporte de Ventas",
    value: "menuReporteVentas",
    icon: "trend",
    component: ReporteVentasManagement,
    url: "/reporte-ventas",
  },
  {
    name: "CLABES",
    value: "menuClabes",
    icon: "bank",
    component: ClabesManagement,
    url: "/clabes",
  },
  {
    name: "Perfil",
    value: "menuPerfil",
    icon: "user",
    component: PerfilManagement,
    url: "/perfil",
  },
  {
    name: "Usuarios",
    value: "menuUsuarios",
    icon: "users",
    component: UserManagement,
    url: "/usuarios",
  },
  {
    name: "ACL",
    value: "menuACL",
    icon: "key",
    component: ACLManagement,
    url: "/acl",
  },
  {
    name: "Empresas",
    value: "menuEmpresas",
    icon: "building",
    component: EmpresaManagement,
    url: "/empresas",
  },
  {
    name: "Pagadoras",
    value: "menuPagadoras",
    icon: "card",
    component: PagadorasManagement,
    url: "/pagadoras",
  },
  {
    name: "Asignaciones",
    value: "menuAsignaciones",
    icon: "edit",
    component: AsignacionesManagement,
    url: "/asignaciones",
  },
  {
    name: "Visitas",
    value: "menuVisitas",
    icon: "pin",
    component: VisitasManagement,
    url: "/visitas",
  },
  {
    name: "Logs",
    value: "menuLogs",
    icon: "file",
    component: LogsManagement,
    url: "/logs",
  },
  {
    name: "BackUps",
    value: "menuBackUps",
    icon: "save",
    component: BackupsManagement,
    url: "/backups",
  },
  {
    name: "Sesiones Activas",
    value: "menuSesiones",
    icon: "monitor",
    component: SesionesManagement,
    url: "/sesiones",
  },
  {
    name: "Reporte de Texto",
    value: "menuReporteTexto",
    icon: "doc",
    component: ReporteTextoManagement,
    url: "/reporte-texto",
  },
  {
    name: "Ayuda",
    value: "menuAyuda",
    icon: "book",
    component: AyudaManagement,
    url: "/ayuda",
    requiresACL: "sysAdmin",
  },
  {
    name: "Parametricos",
    value: "menuParametricos",
    icon: "settings",
    component: ParametricosManagement,
    url: "/parametricos",
    requiresACL: "sysAdmin",
  },
];

// Páginas que aún no tienen componente (mostrarán "Próximamente")
export const pendingPages: Array<{ name: string; value: string; icon: IconName; url: string }> = [
];

// Combinar todas las páginas para el menú
export const allMenuItems: MenuItem[] = [
  ...dashboardPages.map((page) => ({
    name: page.name,
    url: page.url,
    value: page.value,
    icon: page.icon,
    requiresACL: page.requiresACL,
  })),
  ...pendingPages,
];
